var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 223,
    height: 254,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M176.93 121.566c24.461-9.9 36.692-29.268 36.692-58.054C213.622 21.155 184.085 0 124.963 0c-14.55 0-33.549 1.11-57.043  3.284-10.877 1.45-16.34 7.873-16.34 19.223v171.99c0 4.105 1.934 5.795 5.802 5.071l8.363-1.449c3.384-1.207 5.075-3.622 5.075-7.245v-61h53.756c53.031 0 79.57 18.16 79.57 54.432 0 26.419-18.224  47.284-42.83 50.375-1.644.386-5.27.434-5.27.434H19.24V27.385c0-4.105-1.934-5.796-5.801-5.071l-8.363 1.449C1.692 24.97 0 27.385 0 31.007v203.77C0 247.625 6.188 254 18.515 254h137.532c1.015 0 2.127-.097  3.239-.29 19.095-1.497 29.681-8.21 38.286-14.44C214.54 227.05 223 209.227 223 185.754c.048-32.408-15.324-53.804-46.07-64.189ZM72 113V22.295C89.86 20.115 108.202 19 126.977 19c23.396 0 40.583 3.78  51.559 11.29C189.512 37.8 195 49.72 195 65.952c0 15.069-4.766 26.649-14.298 34.79-9.532 8.14-23.348 12.21-41.401 12.21L72 113Z",
    fill: "#fff",
    fillRule: "nonzero"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e15d180acd81b08fc7fc8ed2d124d4db.svg";
export { ForwardRef as ReactComponent };